import React from 'react'
import { IonCard, IonItemDivider, IonLabel, IonToolbar } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import useDeviceMetrics from '../../../utilities/useDeviceMetrics'
import MedicalHistoryButtons from '../page/MedicalHistoryButtons/MedicalHistoryButtons.component'
import { useSelector } from 'react-redux'
import { getPatientMedicalHistorySelector } from '../selectors'
import MedicalHistoryForm from '../page/MedicalHistoryForm/MedicalHistoryForm.component'

const PatientMedicalHistoryContent: React.FC = () => {
  const { t } = useTranslation()
  const { isTablet: isTabletDevice } = useDeviceMetrics()
  const patientMedicalHistory = useSelector(getPatientMedicalHistorySelector)
  const { noKnownHistory } = patientMedicalHistory

  return (
    <>
      <IonItemDivider color='light' className={isTabletDevice ? 'ion-padding divider-padding' : 'ion-hide-sm-down'}>
        <IonLabel className='grid-item-divider-label' color='medium'>
          {t('patientMedicalHistory.Details')}
        </IonLabel>
      </IonItemDivider>

      <IonCard className={isTabletDevice ? 'card-width' : 'card-margin no-rounding'}>
        <IonToolbar className='toolbar-paddinggg' style={{ margin: '0' }}>
          <IonLabel className='toolbar-label' slot='start'>
            {t('patientMedicalHistory.PatientHistory')}:
          </IonLabel>
        </IonToolbar>
        {!noKnownHistory && (
          <>
            <MedicalHistoryButtons />
            <MedicalHistoryForm />
          </>
        )}
      </IonCard>
    </>
  )
}

export default PatientMedicalHistoryContent
